export default {
  "segmentedControl": "_segmentedControl_1aet3_1",
  "label": "_label_1aet3_19",
  "disabled": "_disabled_1aet3_26",
  "thumb": "_thumb_1aet3_35",
  "small": "_small_1aet3_54"
};import "ni:sha-256;5fhNArvzxlRX7mFxoZONScU_pkLJPg9-E4iNcFjWSx8";